var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"detial-cont-title"},[_vm._v("审批轨迹")]),_vm._v(" "),_c('blank',{attrs:{"height":"1"}}),_vm._v(" "),_c('div',{staticClass:"detial-cont-view"},[_c('a-table',{attrs:{"pagination":false,"columns":_vm.columns,"data-source":_vm.getHighLine.formDTOList}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3fd6cb21","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/FixedAssets/components/approvalTrack.vue
// module id = null
// module chunks = 